export const VITRINS_OFFER_CARD_TEXTS = {
  PSK: 'ПСК',
  RATE: 'Ставка',
  SUM: 'Сумма',
  TERM: 'Срок',
  GRACE_PERIOD: 'Льготный период',
  CARD_LIMIT: 'Лимит',
  MAINTENANCE: 'Обслуживание',
};
